import { videoPlayer } from 'vue-video-player'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'

export default {
    name: "mexpansion",
    components: {
        videoPlayer
    },
    data() {
        return {
            lessonId: 0,
            expansionSupplement: null,
            imgSrc: '',
            fromPage: 0,
            playerOptions: {
                //播放速度
                playbackRates: [0.5, 1.0, 1.5, 2.0],
                //如果true,浏览器准备好时开始回放。
                autoplay: false,
                // 默认情况下将会消除任何音频。
                muted: false,
                // 导致视频一结束就重新开始。
                loop: false,
                // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                preload: 'auto',
                language: 'zh-CN',
                // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                aspectRatio: '16:9',
                // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                fluid: true,
                sources: [{
                    //类型
                    type: "video/mp4",
                    //url地址
                    src: ''
                }],
                //你的封面地址
                poster: '',
                //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                notSupportedMessage: '此视频暂无法播放，请稍后再试',
                controlBar: {
                    timeDivider: true,
                    durationDisplay: true,
                    remainingTimeDisplay: false,
                    //全屏按钮
                    fullscreenToggle: true
                }
            }
        }
    },
    methods: {
        getStateHeight: function () {
            return this.isWeixinBrowser() ? 15 : this.getCount(this.$store.state.statusheight);
        },
        showStatusWhite:function (status) {
            let that = this;

            if (that.isAppIos()) {
                document.location = "readingclubapp:changeStatusStyle:" + status;
            }

            if (that.isAppAndroid()) {
                window.note.changeStatusStyle(status);
            }
        },
        getNavCount: function () {
            return this.getStateHeight() + 44;
        },
        goBack: function () {
            this.$router.go(-1);
        },
        judgePlatform: function () {
            let that = this;
            // 平台（0-其它平台 1-微信IOS平台 2-微信android平台 3-app平台IOS平台 4-app平台android平台）
            let Platform = 0;
            let token = that.$store.state.token;
            let userid = that.$store.state.userid.toString();

            if (that.isWeixinBrowser()) {
                // 微信平台
                if (that.isAppIos()) {
                    Platform = 1;
                } else {
                    Platform = 2;
                }
            } else if (!that.isEmpty(token) && !that.isEmpty(userid) && token.length > userid.length) {
                // app平台
                if (that.isAppIos()) {
                    Platform = 3;
                } else {
                    Platform = 4;
                }
            } else {
                Platform = 0;
            }

            return Platform;
        },
        stopOtherAudio: function () {
            let that = this;
            let vPlatform = that.judgePlatform();

            if (vPlatform === 3) {
                document.location = "readingclubapp:stopOtherAudio";
            }

            if (vPlatform === 4) {
                window.note.stopOtherAudio();
            }
        },
    },
    beforeCreate() {
        let that = this;
        let vLessonId = that.getCount(this.$route.query.lessonId);
        let vFromPage = that.getCount(that.$route.query.fromPage);
        let url = "mathStart/getExpansionSupplementInfo/" + vLessonId;
        this.$axios.get(url).then((response) => {
            that.lessonId = vLessonId;
            that.fromPage = vFromPage;
            that.expansionSupplement = response.data;

            if (!that.isEmpty(that.expansionSupplement.video)) {
                that.stopOtherAudio();

                let videoUrl = that.$qiNiuDomainBase + that.expansionSupplement.video;
                that.playerOptions.poster = videoUrl + "?vframe/jpg/offset/5";
                that.playerOptions.sources[0].src = videoUrl;
            }

            if (!that.isWeixinBrowser()) {
                that.$nextTick(() => {
                    $(window).scroll(function () {
                        var scrollTop = parseFloat(parseFloat($(window).scrollTop()));

                        if (scrollTop > 44) {
                            $("#navigation_title").removeClass("navigation");
                            $("#navigation_title").addClass("navigation_white");
                        } else {
                            $("#navigation_title").removeClass("navigation_white");
                            $("#navigation_title").addClass("navigation");
                        }
                    });
                });
            }
        }).catch(function (error) {
            window.console.log(error)
        });
    },
    activated() {
        window.scrollTo(0, 0);
    },
    beforeRouteEnter(to, form, next) {
        next(vm=>{
            vm.showStatusWhite(1);
        });
    },
    beforeRouteLeave(to, form, next) {
        this.showStatusWhite(0);
        next();
    },
}
